import React, { useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalContent,
  ModalFooter,
  Button,
  FormFieldInputNew,
  Notification,
  ThreeDotLoader,
} from "@netapp/bxp-design-system-react";
import { useTranslation } from "react-i18next";
import "./Subscribe.scss"; // Make sure to import your CSS file

const UnsubscribeOtpModal = ({
  email,
  advisoryId,
  open,
  setOpen,
  notification,
  setNotification,
}) => {
  const { t } = useTranslation();
  const [otp, setOtp] = useState("");
  const [isLoading, setIsLoading] = useState(false); // State to manage loading

  const confirmUnsubscribeOtp = async () => {
    const url = `${process.env.REACT_APP_API_BASE_URL}/otp_unsub`;
    const body = {
      adv_id: advisoryId,
      subscriber: email,
      otp: otp,
    };

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      });

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const data = await response.json();
      console.log("OTP confirmation for unsubscription successful:", data);
      setNotification({
        visible: true,
        message: t("modal_unsubscriptionConfirmed.other"),
        type: "success",
      });
      setTimeout(() => {
        setNotification({
          visible: false,
          message: "",
          type: "success",
        });
        setOpen(false);
      }, 4000);
      console.log("Notification set to visible: Unsubscription confirmed!");
    } catch (error) {
      console.error("OTP confirmation for unsubscription failed:", error);
      setNotification({
        visible: true,
        message: t("modal_otpConfirmationFailed.other"),
        type: "error",
      });
      setTimeout(() => {
        setNotification({
          visible: false,
          message: "",
          type: "error",
        });
      }, 4000);
      console.log("Notification set to visible: OTP confirmation failed");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      {open && (
        <Modal className="subscribe-modal">
          <ModalHeader className="modal-header">
            {advisoryId === 'ntap_all' ? t("advisory_unsubscribeAllUpdates.other") : t("advisory_unsubscribeFromAdvisory.other", { id: advisoryId })}
          </ModalHeader>
          <ModalContent>
            <div>
              {notification.visible && (
                <Notification type={notification.type}>
                  {notification.message}
                </Notification>
              )}
            </div>
            <FormFieldInputNew
              className="form-field-input-new"
              label={t("modal_otpForEmail.other", { email })}
              type="text"
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
            />
          </ModalContent>
          <ModalFooter>
            <Button color="secondary" onClick={() => setOpen(false)}>
              {t("modal_cancel.other")}
            </Button>
            <Button
              onClick={() => {
                setIsLoading(true); // Set loading state to true immediately
                confirmUnsubscribeOtp();
              }}
              disabled={!otp || isLoading}
            >
              {isLoading ? (
                <div style={{ display: "flex", alignItems: "center" }}>
                  <ThreeDotLoader />
                  <span style={{ marginLeft: 8 }}>{t("modal_confirm.other")}</span>
                </div>
              ) : (
                t("modal_confirm.other")
              )}
            </Button>
          </ModalFooter>
        </Modal>
      )}
    </>
  );
};

export default UnsubscribeOtpModal;
